import { useEffect } from 'react';
import { usePage, useGallery } from 'app/hooks';

export default () => {
  const page = usePage();
  const gallery = useGallery();

  const headerHeight = () => {
    const header = document.getElementById('header-wrapper');
    return header ? header.clientHeight : 87;
  };

  useEffect(() => {
    if (!page.isLoaded()) {
      return;
    }

    // Call scrollTo as a statement — never return its result. An effect's return
    // value is treated as the cleanup function, and in some browsers (e.g. Chrome
    // 150) window.scrollTo returns a Promise, which React then tries to invoke as
    // cleanup on the next run ("destroy is not a function").
    if (gallery.isIstock()) {
      const height = headerHeight();
      window.scrollTo(0, window.pageYOffset >= height ? height : 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, [page.status]);
};
